import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-member-dialog',
  templateUrl: './team-member-dialog.component.html',
  styleUrls: ['./team-member-dialog.component.css']
})
export class TeamMemberDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
